module.exports = __webpack_public_path__ + "static/assets/6392d7f16ef463fee72810e1570bc886.png";